// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__sP2Dd","footer":"Form_footer__euN7-"};